import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as summarizeSpokenTextServices from '@iso/services/listening/summarizeSpokenText';

//#region CRUD
export function* getSummarizeSpokenText() {
	yield takeLatest(actions.GET_SUMMARIZE_SPOKEN_TEXT, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeSpokenTextServices.getSummarizeSpokenText, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_SUMMARIZE_SPOKEN_TEXT_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getSummarizeSpokenTextDetail() {
	yield takeLatest(actions.GET_SUMMARIZE_SPOKEN_TEXT_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(summarizeSpokenTextServices.getSummarizeSpokenTextDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesSummarizeSpokenText() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_SUMMARIZE_SPOKEN_TEXT, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeSpokenTextServices.createQuesSummarizeSpokenText, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateSummarizeSpokenTextDetail() {
	yield takeLatest(actions.UPDATE_SUMMARIZE_SPOKEN_TEXT_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(summarizeSpokenTextServices.updateSummarizeSpokenTextDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteSummarizeSpokenText() {
	yield takeLatest(actions.DELETE_SUMMARIZE_SPOKEN_TEXT, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(summarizeSpokenTextServices.deleteSummarizeSpokenText, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getSummarizeSpokenText),
		fork(getSummarizeSpokenTextDetail),
		fork(createQuesSummarizeSpokenText),
		fork(updateSummarizeSpokenTextDetail),
		fork(deleteSummarizeSpokenText),
	]);
}
